function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
import { TouchableOpacity, StyleSheet } from 'react-native';

const LinkButton = _ref => {
  let {
    style,
    title,
    icon,
    theme,
    color = theme.colors.button.primary,
    textType = TextType.Caption1,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, props, {
    style: [styles.container, style, {
      flexDirection: theme.isRTL ? 'row-reverse' : 'row'
    }],
    accessibilityRole: 'button',
    activeOpacity: 0.5
  }), icon && /*#__PURE__*/React.cloneElement(icon, theme.isRTL ? {
    marginStart: 8
  } : {
    marginEnd: 8
  }), /*#__PURE__*/React.createElement(Text, {
    color: color,
    allowFontScaling: false,
    type: textType,
    numberOfLines: 1
  }, title));
};

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 10
  }
});
export default withTheme(LinkButton);
//# sourceMappingURL=LinkButton.js.map